import { EmailActionType, EmailMultisigSettingsResponse, EmailNotificationSettings } from 'types';

import { STXAxiosInstance } from '../Axios/STXAxiosInstance';

export const updateSafeEmail = async (
  email: string,
  safeId: string,
  actionType: EmailActionType,
  defaultEmail: boolean
) => {
  const params = new URLSearchParams({
    email: email,
    multisigId: safeId,
    type: actionType,
  });

  if (defaultEmail) {
    params.append('defaultFlag', defaultEmail.toString());
  }

  const url = `email?${params.toString()}`;

  return STXAxiosInstance.get(url).then((data) => data.data);
};

export const verifySafeEmail = async (
  email: string,
  code: string,
  safeId: string,
  actionType: EmailActionType,
  defaultEmail?: boolean
): Promise<EmailMultisigSettingsResponse> => {
  const params = new URLSearchParams({
    email: email,
    code: code,
    multisigId: safeId,
    type: actionType,
  });

  if (defaultEmail) {
    params.append('defaultFlag', defaultEmail.toString());
  }

  const url = `email/verify?${params.toString()}`;

  return STXAxiosInstance.get(url).then((data) => data.data);
};

export const unlinkSafeEmail = async (email: string, safeId: string) => {
  const params = new URLSearchParams({
    email: email,
    multisigId: safeId,
  });

  return STXAxiosInstance.delete<{ success: boolean }>(
    `email/unlink-email?${params.toString()}`
  ).then((response) => response.data);
};

export const setEmailSettings = async (
  email: string,
  safeId: string,
  settingKey: keyof EmailNotificationSettings,
  settingValue: boolean
) =>
  STXAxiosInstance.put<EmailMultisigSettingsResponse>('/email/notifications', {
    email,
    multisigId: safeId,
    settings: {
      [settingKey]: settingValue,
    },
  }).then((data) => data.data);

export const getEmailSettings = async (safeId: string) =>
  STXAxiosInstance.get<EmailMultisigSettingsResponse>(
    `/email/settings?multisigId=${safeId}&defaultFlag=true`
  ).then((data) => data.data);

export const archiveMultisig = async (id: string, type: string) =>
  STXAxiosInstance.get(`/multi-sigs/archived/${id}/${type}`, {}).then((data) => data.data);

export const applyDefaultEmail = async (safeId: string) =>
  STXAxiosInstance.post<{ success: boolean }>(`/email/apply`, { multisigIds: [safeId] }).then(
    (data) => data.data
  );
